module.exports = __webpack_public_path__ + "static/LFS0089-WebBanner-c71fc06eb256e49f7e2276209f28d503.png";